function Service(){
    return(
        <h1>Serviços</h1>
    )
}

export default Service;